import module from 'fan/proyecto/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase()

export class FanProyectoColaboradoresIDSEPendientesComponent {
  data
  filtro = ''

  $onChanges (changes) {
    if (changes.data) {
      this.data = orderBy(this.data, ['descripcion', 'nombre', 'apellido_paterno', 'apellido_materno'])
      this.data.forEach((item) => (item.busqueda = normalizar(`${item.nombre}|${item.rfc}|${item.descripcion}`)))
      this.filtrar()
    }
  }

  filtrar () {
    let filtro = normalizar(this.filtro)
    this.resultados = this.data.filter((item) => item.busqueda.indexOf(filtro) >= 0)
  }
}

module.component('fanProyectoColaboradoresIdsePendientes', {
  controller: FanProyectoColaboradoresIDSEPendientesComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/idse/pendientes/component.js